/* @flow */

const formatarCep = (cep: string) => cep.replace(/(\d{5})(\d{3})/, '$1-$2');

export default formatarCep;
